/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_Entitlements_QuestionInputs */

const en_landing_faq_entitlements_question = /** @type {(inputs: Landing_Faq_Entitlements_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is client access controlled?`)
};

/**
* | output |
* | --- |
* | "How is client access controlled?" |
*
* @param {Landing_Faq_Entitlements_QuestionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_faq_entitlements_question = /** @type {((inputs?: Landing_Faq_Entitlements_QuestionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_Entitlements_QuestionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_faq_entitlements_question(inputs)
});